import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export enum ButtonColors {
  Default = '',
  Primary = 'primary',
  Accent = 'accent',
  Warn = 'warn',
  Disabled = 'disabled'
}

export enum ButtonTypes {
  Submit,
  Button,
  Link,
  Toggle
}

export interface ButtonBarItem {
  label: string;
  name: string;
  color?: string;
  icon?: string;
  type?: string;
  onClick?: (event, ...args) => void;
  files?: FileList;
  filters?: any;
}



@Component({
  selector: 'vias-buttonbar',
  templateUrl: './buttonbar.component.html',
  styleUrls: ['./buttonbar.component.scss']
})
export class ButtonbarComponent implements OnInit {
  @Input() numLocale: string;
  @Input() class: string;
  @Input() buttons: ButtonBarItem[];
  @Output() itemClick: EventEmitter<ButtonBarItem> = new EventEmitter<ButtonBarItem>();
  constructor() { }

  ngOnInit(): void {
    this.buttons.forEach(btn => {
      if(btn.color === undefined){
        btn.color = ButtonColors.Default;
      }
    });
  }

  buttonItemClick($event): void {
    let buttonId = '';
    if ($event.target['name'] || $event.currentTarget['name']) {
      buttonId = $event.target['name'] !== undefined ? $event.target['name'] : $event.currentTarget['name'];
      const selection: ButtonBarItem = this.buttons.find(e => e['name'] === buttonId);
      if ($event.target.files !== undefined){
        selection.files = $event.target.files;
      }
      if (selection) {
        this.itemClick.emit(selection);
      }
    }
  }
}
